export default function CreditBalanceAfter({ value, english = false }) {
  const hasValue = value !== null && value !== undefined && String(value).trim() !== '' && Number.isFinite(Number(value));
  const label = english ? 'Balance after' : '变动后余额';
  const balance = hasValue
    ? `${Number(value).toLocaleString(english ? 'en-US' : 'zh-CN')} ${english ? 'credits' : '点'}`
    : '—';

  return (
    <div className="credit-balance-after" aria-label={`${label}：${balance}`} title={hasValue ? undefined : (english ? 'Balance unavailable' : '暂无余额记录')}>
      <span className="credit-balance-after__label">{label}</span>
      <strong>{balance}</strong>
    </div>
  );
}
